module.exports = __webpack_public_path__ + "static/media/21_BOJO_MEIA_TACA_ESTAMPADO_01.6912c07b.jpg";